import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import useDashboardGraphData from "./useDashboardGraphData";
import RechartsTemplate from "./NivoTemplate";
import EChartsTemplate from "./EChartsTemplate";
import NivoLineTemplate from "./NivoLineTemplate";
import EChartsTemplate2 from "./EChartsTemplate2";

const PAGE_BG = "#0d1117";
const PANEL_BG = "#13171f";

export default function GraphTemplatesPage() {
  const [tab, setTab] = useState(0);
  const { isLoading, isError, microServiceGraphData, targetDataNow, microserviceForcastState, lspsState } =
    useDashboardGraphData();

  const sharedProps = { microServiceGraphData, targetDataNow, microserviceForcastState, lspsState };

  return (
    <Box
      sx={{
        bgcolor: PAGE_BG,
        minHeight: "100vh",
        color: "#e0e6f0",
        pt: 10,
        pb: 6,
        px: { xs: 2, md: 4 },
        maxWidth: 1350,
        mx: "auto",
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, color: "#e0e6f0", mb: 1, letterSpacing: 0.5 }}
      >
        Graph Templates
      </Typography>
      <Typography variant="body2" sx={{ color: "#5a6070", mb: 3 }}>
        Alternative visualisations using the same live data. Existing dashboard is unchanged.
      </Typography>

      <Box sx={{ borderBottom: "1px solid #1e2330", mb: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          TabIndicatorProps={{ style: { backgroundColor: "#2E93fA" } }}
          sx={{
            "& .MuiTab-root": { color: "#5a6070", textTransform: "none", fontWeight: 500 },
            "& .Mui-selected": { color: "#e0e6f0" },
          }}
        >
          <Tab label="Chart.js" />
          <Tab label="ECharts" />
          <Tab label="Nivo" />
          <Tab label="ECharts 2" />
        </Tabs>
      </Box>

      {isLoading && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 6 }}>
          <CircularProgress size={24} sx={{ color: "#2E93fA" }} />
          <Typography sx={{ color: "#5a6070" }}>Loading graph data…</Typography>
        </Box>
      )}

      {isError && !isLoading && (
        <Box
          sx={{
            bgcolor: PANEL_BG,
            borderRadius: 2,
            p: 3,
            mt: 2,
            border: "1px solid #2a2f3d",
          }}
        >
          <Typography sx={{ color: "#e05050" }}>
            Could not load dashboard data. Check the API is running.
          </Typography>
        </Box>
      )}

      {!isLoading && !isError && (
        <Box sx={{ bgcolor: PANEL_BG, borderRadius: 2, p: 3 }}>
          {tab === 0 && <RechartsTemplate {...sharedProps} />}
          {tab === 1 && <EChartsTemplate {...sharedProps} />}
          {tab === 2 && <NivoLineTemplate {...sharedProps} />}
          {tab === 3 && <EChartsTemplate2 {...sharedProps} />}
        </Box>
      )}
    </Box>
  );
}
